import { HierarchyContext } from "contexts/HierarchyContext";
import { useContext } from "react";
import { NavDropdown } from "react-bootstrap";

interface SettingsDropMenuProps {
  settingsEntry?: React.ReactElement;
}

/**
 * Menu that displays application and hierarchy specific settings.
 *
 * @param props - Destructured props for the settings menu.
 * @param props.settingsEntry - Optional custom element to render at the top of the menu.
 * @returns A JSX element rendering the settings dropdown or an empty fragment.
 */
export const SettingsDropMenu = ({ settingsEntry }: SettingsDropMenuProps) => {
  const hierarchyContext = useContext(HierarchyContext);
  const hierarchies =
    hierarchyContext && hierarchyContext.hierarchy
      ? Array.from(new Set([hierarchyContext.hierarchy, ...hierarchyContext.hierarchyNodes]))
      : // istanbul ignore next
        undefined;

  return !hierarchies || !settingsEntry ? null : (
    <NavDropdown
      title="Settings"
      id="settingsdropmenu"
      className="align-self-center"
    >
      <div style={{ maxHeight: "75vh", overflowY: "auto" }}>{settingsEntry}</div>
    </NavDropdown>
  );
};

SettingsDropMenu.displayName = "SettingsDropMenu";
